
import RcDomainObject from "@/domain/common/RcDomainObject.js";

export default class Role extends RcDomainObject {
  static MODEL_NAME = "UserRole";
      
  static FIELDS = {
      NAME: "name",
  }
  
  constructor(domain, data) {
    super(domain, data, Role.MODEL_NAME);
  }

  fields() {
    return Role.FIELDS;
  }
  
  isAdministrator() {
    return this.name() === "administrator";
  }
  
  isDriver() {
    return this.name() === "driver";
  }

  isMechanic() {
    return this.name() === "mechanic";
  }
  
  isManager() {
    return this.name() === "manager";
  }
  
  isOwner() {
    return this.name() === "owner";
  }
  
  name() {
    return this.getString(Role.FIELDS.NAME);
  }
  
}